import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable max-len */
import { Box, CircularProgress } from '@mui/material';
import React from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks';
import { emptySeniorDetail, emptySeniorImage, resetLocationDates, setSeniorImage, } from 'store/commonReducer/common.action';
import { getDashboardCareInsight } from 'pages/WCPages/SeniorDashboard/components/CareInsights/CareInsights.action';
import MemoryCareResidentDashboard from './MemoryCareResidentDashboard.component';
import { FACILITY_TYPES, Roles } from 'globals/enums';
import IndependentLivingResidentDashboard from './IndependentLivingResidentDashboard.component';
import UnauthorizedAccess from 'common/UnauthorizedAccess';
import { hideFacilityBreadcrumb, showFacilityBreadcrumb } from 'pages/WCPages/Admin/CorporateAndFacilities/FacilityManagement/FacilityManagement.action';
import { SubHeader } from 'common/SubHeader';
var ResidentDashboard = function () {
    var seniorDetail = useAppSelector(function (state) { return state.common; }).seniorDetail;
    var minimalInfo = seniorDetail.minimalInfo, isLoading = seniorDetail.isLoading;
    var dispatch = useAppDispatch();
    var userRole = useAppSelector(function (state) { return state.auth.roleConfig.role; });
    React.useEffect(function () {
        dispatch(setSeniorImage());
        dispatch(getDashboardCareInsight());
        return function () {
            dispatch(emptySeniorDetail());
            dispatch(emptySeniorImage());
            dispatch(resetLocationDates());
        };
    }, []);
    if (isLoading) {
        return (_jsx(Box, { display: 'flex', justifyContent: 'center', alignItems: 'center', "data-testid": 'loader', height: 'calc(100vh - 180px)', children: _jsx(CircularProgress, {}) }));
    }
    var selectedFacilityType = sessionStorage.getItem('currentFacilityType');
    if (selectedFacilityType === 'Home Care') {
        selectedFacilityType = 'Memory Care';
    }
    if (minimalInfo.facility_type === 'Home Care')
        minimalInfo.facility_type = 'Memory Care';
    selectedFacilityType = selectedFacilityType
        .split('_')
        .map(function (x) { return x.toUpperCase(); })
        .join(' ');
    if (userRole &&
        userRole !== Roles.Admin &&
        userRole !== Roles.Admin_WellnessServices &&
        selectedFacilityType !== minimalInfo.facility_type.toUpperCase()) {
        dispatch(hideFacilityBreadcrumb());
        return _jsx(UnauthorizedAccess, {});
    }
    dispatch(showFacilityBreadcrumb());
    if (minimalInfo.facility_type === FACILITY_TYPES.INDEPENDENT_LIVING) {
        return (_jsxs(_Fragment, { children: [_jsx(SubHeader, {}), _jsx(IndependentLivingResidentDashboard, {})] }));
    }
    return (_jsxs(_Fragment, { children: [_jsx(SubHeader, {}), _jsx(MemoryCareResidentDashboard, {}), ";"] }));
};
export default ResidentDashboard;
